import React from "react";
import { SwipeableDrawer, Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Divider, Collapse } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import HmisLogo from "../../../../components/CustomButton/HmisLogo/HmisLogo";
import SettingsIcon from "@mui/icons-material/Settings";
import HelpIcon from "../../../../assets/images/helpIcon.png";

interface MobileDrawerProps {
  open: boolean;
  onClose: () => void;
  onOpen: () => void;
  openMenu: any;
  pathname: string;
  menuConfig: any[];
  onNavigate: (route: string) => void;
  onMenuClick: (key: any) => void;
  routeMap: Record<string, string>;
}

export const MobileDrawer: React.FC<MobileDrawerProps> = React.memo(({
  open,
  onClose,
  onOpen,
  openMenu,
  pathname,
  menuConfig,
  onNavigate,
  onMenuClick,
  routeMap,
}) => {
  const handleToggleDrawer = (anchor: any, shouldClose: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (event && event.type === "keydown" && ((event as React.KeyboardEvent).key === "Tab" || (event as React.KeyboardEvent).key === "Shift")) {
      return;
    }
    const page = event !== undefined ? (event.target as HTMLElement).innerText : null;
    if (page && routeMap[page]) {
      onNavigate(routeMap[page]);
    }
    if (shouldClose) onClose();
  };

  return (
    <SwipeableDrawer anchor="left" open={open} onClose={onClose} onOpen={onOpen}>
      <List style={{ width: "33vh" }}>
        <Box sx={{ display: "flex", justifyContent: "start", marginTop: "7px", marginLeft: "14px", marginBottom: "7px" }}>
          <HmisLogo className="logo nav-logo" size={38} />
        </Box>
        <Divider />
        <Box sx={{ display: "flex", justifyContent: "space-between", flexDirection: "column", height: "100%", paddingTop: "15px" }}>
          <Box>
            {menuConfig.map((item: any) => {
              if (item.condition === false) return null;
              
              if (item.type === 'simple') {
                return (
                  <ListItem key={item.key} disablePadding className={item.route === pathname ? "active-master-class" : "nav-ListItemButton"} sx={{ display: "block" }} onClick={() => onNavigate(item.route)}>
                    <ListItemButton sx={{ minHeight: 24, px: 1.3, "&:hover": { backgroundColor: "#3b75ff", color: "#ffffff" } }}>
                      <ListItemIcon className="nav-ListItemButton" sx={{ minWidth: 0, mr: 3, justifyContent: "center" }}>
                        <span className="menu-icon-span">{item.icon}</span>
                      </ListItemIcon>
                      <ListItemText primary={item.label} className="menu-item-text" />
                    </ListItemButton>
                  </ListItem>
                );
              }
              
              const isActive = item.activeRoutes?.some((route: string) => pathname === route);
              return (
                <ListItem key={item.key} disablePadding className="nav-ListItemButton" sx={{ display: "block" }}>
                  <ListItemButton onClick={() => onMenuClick(item.key)} sx={{ minHeight: 24, px: 1.3, borderRadius: "12px", "&:hover": { backgroundColor: "#e9eefa", color: "#3b75ff" } }}>
                    <ListItemIcon className="nav-ListItemButton" sx={{ minWidth: 0, mr: 3, justifyContent: "center" }}>
                      <span className="menu-icon-span">{item.icon}</span>
                    </ListItemIcon>
                    <ListItemText primary={item.label} className={isActive ? "active-master-class-icon menu-item-text" : "menu-item-text"} />
                    {openMenu[item.key] ? <ExpandLess className={isActive ? "active-master-class-icon menu-item-icon-more" : "menu-item-icon-more"} /> : <ExpandMore className={isActive ? "active-master-class-icon menu-item-icon-more" : "menu-item-icon-more"} />}
                  </ListItemButton>
                  <Collapse in={openMenu[item.key]} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {item.subItems?.map((subItem: any) => (
                        <ListItemButton key={subItem.label} className={subItem.route === pathname ? "active-master-class sub-menu" : "sub-menu"} sx={{ pl: 4, borderRadius: "12px", "&:hover": { backgroundColor: "#e9eefa", color: "#3b75ff" } }} onClick={handleToggleDrawer("left", true)}>
                          <ListItemText primary={subItem.label} />
                        </ListItemButton>
                      ))}
                    </List>
                  </Collapse>
                </ListItem>
              );
            })}
            <ListItem key="Settings" disablePadding className={"/settings" === pathname ? "active-master-class" : "nav-ListItemButton"} sx={{ display: "block" }} onClick={() => onNavigate('/settings')}>
              <ListItemButton sx={{ minHeight: 24, px: 1.3, "&:hover": { backgroundColor: "#3b75ff", color: "#ffffff" } }}>
                <ListItemIcon className="nav-ListItemButton" sx={{ minWidth: 0, mr: 3, justifyContent: "center" }}>
                  <span className="menu-icon-span"><SettingsIcon className="menu-icon" /></span>
                </ListItemIcon>
                <ListItemText primary="Settings" className="menu-item-text" />
              </ListItemButton>
            </ListItem>
            <ListItem key="Help" disablePadding className={"/help" === pathname ? "active-master-class" : "nav-ListItemButton"} sx={{ display: "block" }} onClick={() => onNavigate('/help')}>
              <ListItemButton sx={{ minHeight: 24, px: 1.3, "&:hover": { backgroundColor: "#3b75ff", color: "#ffffff" } }}>
                <ListItemIcon className="nav-ListItemButton" sx={{ minWidth: 0, mr: 3, justifyContent: "center" }}>
                  <span className="menu-icon-span"><img src={HelpIcon} alt="menu icon" height={25} width={25} /></span>
                </ListItemIcon>
                <ListItemText primary="Help" className="menu-item-text" />
              </ListItemButton>
            </ListItem>
          </Box>
        </Box>
      </List>
    </SwipeableDrawer>
  );
});

MobileDrawer.displayName = "MobileDrawer";
